<div id="divConversionAlert" class="alert {{type}} alert-dismissible fade-in" role="alert" [ngClass]="{'center-text': centertext}">
    <button *ngIf="dismissible" type="button" class="close" data-dismiss="alert" (click)="closeAlert()">
        <span aria-hidden="true">&times;</span>
        <span class="sr-only">Close</span>
    </button>
    <div class="break-text">
        <strong>{{header?header&nbsp;:header}}</strong>{{message}}
    </div>
</div>
